import { GridCell, GridCellProps } from "@progress/kendo-react-grid";

export const DefaultCell = (props: GridCellProps) => {
  const isHighlighted: boolean =
    (props.dataItem?.field_highlight ?? "")
      .toUpperCase()
      .split(",")
      .includes(props.dataItem?.field?.toUpperCase() ?? "") || false;

  return (
    <GridCell
      {...props}
      style={{
        color: isHighlighted ? "red" : "black",
      }}
    >
      {}
    </GridCell>
  );
};